import { render, staticRenderFns } from "./sixAccordion.vue?vue&type=template&id=12e83548&scoped=true&"
import script from "./sixAccordion.vue?vue&type=script&lang=js&"
export * from "./sixAccordion.vue?vue&type=script&lang=js&"
import style0 from "./sixAccordion.vue?vue&type=style&index=0&id=12e83548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e83548",
  null
  
)

export default component.exports